import { put, takeLatest, call } from 'redux-saga/effects';
import { REGISTER_USER } from 'redux/types';
import apiRequest from '@utils/request';
import { browserHistory } from '@src/App';
import {
  registerUserInProgress,
  registerUserSuccess,
  registerUserFailure
} from '@redux/actions/RegisterActions';
import { toast } from 'react-toastify';

export const setRegister = body => {
  return apiRequest('/users/register', {
    method: 'POST',
    body
  });
};

//TODO: move to utils and reuse
export const toastErrorHelper = msg => {
  toast.error(msg, {
    position: 'top-center',
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    progress: 0
  });
};

export function* setUserRegister(data) {
  const {
    firstname,
    lastname,
    title,
    password,
    password2,
    token
  } = data.payload;
  try {
    yield put(registerUserInProgress());

    if (!firstname) {
      toastErrorHelper('Please fill with your name!');
      return;
    }
    if (!lastname) {
      toastErrorHelper('Please fill with your lastname!');
      return;
    }
    if (!title) {
      toastErrorHelper('Please select your title!');
      return;
    }
    if (!password && password !== password2) {
      toastErrorHelper(`Your password doesn't match!`);
      return;
    }

    const obj = {
      title: 'Mr.',
      firstname,
      lastname,
      password,
      token
    };

    const result = yield call(setRegister, obj);

    if (result.data.body === 'Success') {
      browserHistory.push('/');
      toastErrorHelper('Your registration is complete! You can login now.');
      yield put(registerUserSuccess(result.data));
    } else {
      yield put(registerUserFailure());
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    toastErrorHelper('Invalid email or already in use!');
    console.warn('Error on register', error);
    yield put(registerUserFailure(error));
  }
}

export function* watchSetUserRegister() {
  yield takeLatest(REGISTER_USER.START, setUserRegister);
}

export const registerSagas = {
  watchSetUserRegister
};
